var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgTickw(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "1200pt",
    height: "1200pt",
    viewBox: "0 0 1200 1200",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "m1051.2 369.6-538.8 560.4c-30 31.199-78 31.199-108 0l-268.8-282c-30-31.199-30-81.602 0-112.8s78-31.199 108 0l216 225.6 484.8-504c30-31.199 78-31.199 108 0 28.797 31.199 28.797 81.598-1.2031 112.8z",
    fill: "#fff",
    fillRule: "evenodd"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgTickw);
export default __webpack_public_path__ + "static/media/tickw.971dc8cc4d124e48f7922e0a45c6aa3e.svg";
export { ForwardRef as ReactComponent };